import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Label } from 'core/components/label';
import { Card } from 'core/components/card';
import { Button } from 'core/components/button';
import notificationIcon from './assets/alert-small-white.svg';
import chevronRightIcon from './assets/chevron-right.svg';
import useStyles from './update-bill-to-other-notification.styles';

const UpdateBillToOtherNotification = ({ isBillToOtherAdded, onNavigateToDetails }) => {
  const classes = useStyles();

  return (
    <Card className={classNames(classes.card, { [classes.errorCard]: !isBillToOtherAdded })}>
      <img src={notificationIcon} alt="Notification Icon" />
      <Label type="smallWhiteBold">
        How to add a bill to other party:{' '}
        <Label type="label" className={classes.label}>
          Navigate to the details tab and include one as an interested party.
        </Label>
      </Label>
      <Button color="secondary" variant="text" className={classes.button} onClick={onNavigateToDetails}>
        Go to details
        <img src={chevronRightIcon} className={classes.chevronRightIcon} alt="Go to details" />
      </Button>
    </Card>
  );
};

UpdateBillToOtherNotification.propTypes = {
  isBillToOtherAdded: PropTypes.bool,
  onNavigateToDetails: PropTypes.func.isRequired
};

UpdateBillToOtherNotification.defaultProps = {
  isBillToOtherAdded: false
};

export default UpdateBillToOtherNotification;
